module.exports = __webpack_public_path__ + "img/contract-status-4.748d87ac.png";